var _style, _g, _g2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheese(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#315CA7;}\n\t.st1{fill:#F8AA37;}\n\t.st2{fill:#FFD984;}\n\t.st3{fill:#F39110;}\n\t.st4{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.63,182.83c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C29.33,148.54,63.94,182.83,106.63,182.83"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "90.71,69.82 90.68,78.47 104.59,74.86 96.96,69.66 90.71,69.82  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M146.53,115.14c0-2.96,1.98-5.39,4.55-5.82V78.99c-10.41-2.5-88.45,18.71-88.45,18.71v9.2 c4.15,0.78,7.15,4.4,7.15,8.62c0,4.22-3.01,7.84-7.15,8.62v20.07l88.45-16.87v-6.37C148.51,120.53,146.53,118.1,146.53,115.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M100.58,59.89l-10,10c1.91,0.45,3.27,1.54,3.27,2.81c0,1.68-2.33,3.03-5.2,3.03c-1.23,0-2.35-0.26-3.24-0.68 L62.63,97.83c34.25-7.57,57.34-13.75,88.71-18.8C138.7,62.17,109.01,59.89,100.58,59.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M135.48,75.78c0,2.85-3.95,5.15-8.83,5.15c-4.88,0-8.83-2.31-8.83-5.15c0-2.85,3.96-5.16,8.83-5.16 C131.52,70.63,135.48,72.93,135.48,75.78 M99.24,84.13c0,2.55-3.54,4.61-7.9,4.61c-4.36,0-7.9-2.06-7.9-4.61 c0-2.54,3.54-4.6,7.9-4.6C95.71,79.53,99.24,81.59,99.24,84.13 M112.06,67.49c0,1.68-2.33,3.04-5.2,3.04c-2.87,0-5.2-1.36-5.2-3.03 c0-1.68,2.33-3.04,5.2-3.04C109.73,64.45,112.06,65.82,112.06,67.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M111.33,127.15c-3.12,4.17-8.73,5.26-12.51,2.43c-3.79-2.83-4.33-8.51-1.2-12.68 c3.12-4.18,8.73-5.26,12.51-2.43C113.92,117.29,114.46,122.98,111.33,127.15 M109.06,101.1c-1.76,2.11-4.75,2.52-6.67,0.92 c-1.91-1.6-2.04-4.61-0.27-6.72c1.77-2.12,4.75-2.53,6.67-0.92C110.71,95.97,110.83,98.98,109.06,101.1 M134.26,120.29 c-1.31,1.57-3.52,1.87-4.95,0.68c-1.42-1.19-1.51-3.43-0.2-5c1.31-1.57,3.53-1.88,4.95-0.69 C135.48,116.48,135.57,118.72,134.26,120.29 M89.63,107.34c0,3.26-2.4,5.91-5.37,5.91c-2.96,0-5.36-2.65-5.36-5.91 c0-3.27,2.4-5.91,5.36-5.91C87.22,101.42,89.63,104.07,89.63,107.34 M147.51,94.69c0,3.46-2.55,6.27-5.69,6.27 c-3.14,0-5.69-2.8-5.69-6.27c0-3.46,2.55-6.27,5.69-6.27C144.96,88.42,147.51,91.23,147.51,94.69"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M76.75,119.26c0,0-0.19,0.13-0.45,0.29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheese);
export default __webpack_public_path__ + "static/media/Cheese.37cb1eead1bc76d74ea8891636d0f785.svg";
export { ForwardRef as ReactComponent };